import React from 'react';
import { useTranslation } from 'react-i18next';

export interface AppSlideProps {
  image: string;
  index: number;
}

export const AppSlide = ({ image, index }: AppSlideProps) => {
  const { t } = useTranslation('mobileApp');
  return (
    <div className="item-wrp-steps">
      <span className="title">{t(`steps.step${index + 1}`)}</span>
      <img
        className="image"
        src={image}
        width={238}
        height={432}
        alt={`Step ${index + 1}`}
      />
    </div>
  );
};
